export const TESTIMONIAL_DISPLAY_STYLES = {
  CAROUSEL: 'carousel',
  CARDS: 'cards',
} as const;
